import { Component, Input } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { Errors } from './models';

@Component({
  selector: 'list-errors',
  templateUrl: './list-errors.component.html'
})
export class ListErrorsComponent {
  name: { [key: string]: any; };
  formattedErrors: string = "";
  constructor(
    private route: ActivatedRoute,
    private router: Router


  ) {
    route.params.subscribe(params => this.name = params);
  }
  @Input()
  set errors(errorList: Errors) {
    if (errorList.error) {

      this.formattedErrors = `${errorList.message}`;

    }
  };

  get errorList() { return this.formattedErrors; }
  signIn() {
    if (this.name['name'] == 'AUTH')
      this.router.navigateByUrl(`/login`)
    else
      this.router.navigateByUrl(`/plogin/${this.name['name']}`)
  }

}
